'use client';

import { ServerActionName } from '@headless-workspace/config';
import { ContentAssetKeys, ResultServerActionType } from '@headless-workspace/core-domain';
import { ContentAssetType, getContentAssetServerAction } from '../../../../server';
import { useSafeSWRMutation } from '../../hooks';
import { UserRevalidationKey } from '../../user';

type DeliveryReturnsModalMutationReturnType = {
    get: () => Promise<ResultServerActionType<ContentAssetType[]>>;
    isMutating: boolean;
};

export const useDeliveryReturnsModalMutation = (): DeliveryReturnsModalMutationReturnType => {
    const { trigger, isMutating } = useSafeSWRMutation<ContentAssetType[], undefined>(
        UserRevalidationKey.ContentAsset,
        ServerActionName.getContentAssetServerAction,
        () => getContentAssetServerAction([ContentAssetKeys.CartDeliveryPopup]),
    );
    return { get: trigger, isMutating };
};
